import Icon from "@/components/Icon";
import Tooltip from "@/components/Tooltip";
import type { ReactNode } from "react";

type DashboardPrivateTitleProps = {
  title: ReactNode;
  isPrivate?: boolean;
  privateTooltip: string;
};

export default function DashboardPrivateTitle({
  title,
  isPrivate = false,
  privateTooltip
}: DashboardPrivateTitleProps) {
  if (!isPrivate) {
    return <>{title}</>;
  }

  return (
    <span className="inline-flex min-w-0 max-w-full items-start gap-2">
      <span className="min-w-0 break-words">{title}</span>
      <Tooltip variant="plain" supportingText={privateTooltip} compactHoverArea>
        <span aria-label={privateTooltip} className="inline-flex shrink-0">
          <Icon name="lock" size={20} />
        </span>
      </Tooltip>
    </span>
  );
}
